<template>
  <div class="consultation-page">
    <TopBg title="分类信息 - 咨询医生" desc="紧跟行业前沿，传递价值信息" :bg="bg"></TopBg>

    <div class="list-warp">

      <ul class="department-warp">
        <li v-for="item in department" :class="item.isActive?'active':''" @click="changeDepartment(item.name)" :key="item.id">
          {{item.name}}
        </li>
      </ul>

      <ul class="doctor-warp">
        <li v-for="item in doctor" :key="item.id">
          <img class="avatarUrl" :src="item.photo" alt="">
          <div class="content">
            <div class="header">
              <h3>{{item.user_real_name}}</h3>
              <span>{{item.title}}</span>
            </div>
            <p>{{item.hosp_name}}</p>
            <p class="description">{{item.description}}</p>
          </div>
          <div class="price-warp">
            <button class="link-button" :class="item.wx_permission === '1' ?'submit-button':'disable-button' " @click="startChat(item)">
              <img :src="item.wx_permission === '1'?chatIcon:chatGrayIcon">发起咨询
            </button>
            <p v-show="isLogged" v-if="item.wx_permission === '1'">￥{{item.tuwenfee}}元/次</p>
            <p class="no-permission" v-else>暂未开启咨询服务</p>
          </div>
        </li>
      </ul>
      <Loading :showLoading="doctorListLoading"></Loading>
    </div>
    <ConsultationForm :isShowModel="isShowModel" @showModel="showForm" @sendInfo="getInfo"></ConsultationForm>

    <RegisterForm :isShowModel="isShowRegister" @showModel="changeModel"></RegisterForm>
    <PaymentQrCode :isShowModel="isShowQrCode" @showModel="ShowQrCode" :price="price" :qrCode="qrCode"></PaymentQrCode>
  </div>
</template>

<script>
import TopBg from '../components/TopBg.vue';
import ConsultationForm from '../components/ConsultationForm';
import RegisterForm from '../components/RegisterForm'
import PaymentQrCode from '../components/PaymentQrCode'
import Loading from '../components/Loading'

import bg from '../assets/solutions/outhosp/linknet/pic-doctorbg.png';
import chatIcon from '../assets/icon-chat.png'
import chatGrayIcon from '../assets/icon/ic-chat-gray.png'
import doctorIcon from '../assets/icon/icon-default-doctor.png'
import store from "../store"
import {
  getDoctorList,
  submitPatientInfoOrder,
  createOrder,
  getOrderStatus,
  getExistUniteOrder
} from '../services/http'

export default {
  name: "Consultation",
  components: {
    TopBg,
    ConsultationForm,
    RegisterForm,
    PaymentQrCode,
    Loading
  },
  data () {
    return {
      bg,
      chatIcon,
      chatGrayIcon,
      doctorIcon,
      isShowModel: false,
      isShowRegister: false,
      isShowQrCode: false,
      doctorListLoading: true,
      price: null,
      qrCode: '',
      unite_order_id: '',

      department: [
        { name: '外科', isActive: true },
        { name: '内科', isActive: false },
        { name: '肿瘤科', isActive: false },
        { name: '乳腺科', isActive: false },
        { name: '其他', isActive: false },
      ],
      doctor: [],
      currentDoctorInfo: {},
      timer: null,
      local_order_id: '',
    }
  },


  watch: {
    isShowQrCode (newVal) {
      if (!newVal) {
        clearInterval(this.timer);
      }
    }
  },


  computed: {
    isLogged () {
      return store.getters.isLogged;
    },
    userInfo () {
      return this.$store.getters.userInfo;
    }
  },

  mounted () {
    let name = this.department[0].name;
    this.getDoctorList(name);
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  destroyed () {
    clearInterval(this.timer);
  },

  methods: {
    //切换科室
    changeDepartment (name) {
      this.department.forEach(item => {
        item.isActive = item.name === name ? true : false;
      });
      this.getDoctorList(name);
    },

    //获取医生列表
    getDoctorList (name) {
      this.doctorListLoading = true;
      let json = {
        tagName: 'web' + name,
      };
      getDoctorList(json).then(res => {
        this.doctorListLoading = false;
        let doctors = res.data.data;
        doctors.forEach(doctor => {
          doctor.photo = doctor.photo ? doctor.photo : this.doctorIcon;
          doctor.wx_permission = this.isLogged ? doctor.wx_permission : '1';
        });
        this.doctor = doctors;
      })
    },

    //发起咨询
    startChat (info) {
      if (!this.isLogged) {
        alert('请登录后发起咨询');
        return;
      }
      if (this.userInfo) {
        if (this.userInfo.is_need_register) {
          this.isShowRegister = true;
          return;
        }
      }
      this.currentDoctorInfo = info;
      getExistUniteOrder({ doctor_id: info.doctor_id }).then(res => {

        if (res.data.data.unite_order_id != 0) {
          let orderJson = {
            doctor_id: info.doctor_id,
            unite_order_id: res.data.data.unite_order_id,
            good_type: '',
          };
          this.createOrder(orderJson, info.doctor_id);
        } else {
          if (info.wx_permission === '1') {
            this.isShowModel = true;
          }
        }


      })


    },
    createOrder (orderJson, doctor_id) {
      createOrder(orderJson).then(res => {
        console.log(res.data.data);
        this.isShowModel = false;
        this.price = res.data.data.fee;
        this.qrCode = res.data.data.payInfo;
        if (res.data.data.free) {
          this.$router.push({ path: `/consultationDetail/${doctor_id}` })
        } else {
          this.isShowQrCode = true;
          this.local_order_id = res.data.data.local_order_id;
          this.timer = setInterval(() => {
            this.getOrderStatus();
          }, 5000)
        }
      })
    },

    showForm (val) {
      this.isShowModel = val;
    },

    changeModel (val) {
      this.isShowRegister = val;
    },

    ShowQrCode (val) {
      this.isShowQrCode = val;
    },

    getInfo (info) {
      let doctor_id = this.currentDoctorInfo.doctor_id;
      let json = {
        ...info,
        doctor_id,
      };
      submitPatientInfoOrder(json).then(res => {
        let unite_order_id = res.data.data.unite_order_id;
        let orderJson = {
          doctor_id,
          unite_order_id,
          good_type: '',
        };
        createOrder(orderJson).then(res => {
          this.isShowModel = false;
          this.price = res.data.data.fee;
          this.qrCode = res.data.data.payInfo;
          if (res.data.data.free) {
            this.$router.push({ path: `/consultationDetail/${doctor_id}` })
          } else {
            this.isShowQrCode = true;
            this.local_order_id = res.data.data.local_order_id;
            this.timer = setInterval(() => {
              this.getOrderStatus();
            }, 5000)
          }
        })
      })
    },

    getOrderStatus () {
      getOrderStatus({ local_order_id: this.local_order_id }).then(res => {
        let successStatus = [2, 3, 4, 7]; //支付成功的状态；
        if (successStatus.includes(Number(res.data.data))) {
          this.isShowQrCode = false;
          clearInterval(this.timer);
          this.$router.push({ path: `/consultationDetail/${this.currentDoctorInfo.doctor_id}` });
        }
      })
    },

    getExistUniteOrder (json) {
      getExistUniteOrder(json).then(res => {

      })

    },


  }
}
</script>

<style scoped lang="less">
.consultation-page {
  font-size: 14px;
  .list-warp {
    position: relative;
    background: #fff;
    ul {
      max-width: 1000px;
      margin: 0 auto;
    }
    .department-warp {
      display: flex;
      li {
        padding: 0 23px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 44px;
        cursor: pointer;
      }
      .active {
        color: #108ee9;
        border-bottom: 1px solid #108ee9;
      }
    }

    .doctor-warp {
      margin-top: -1px;
      li {
        border-top: 1px solid #d9d9d9;
        padding: 16px 0 15px;
        display: flex;
        .avatarUrl {
          width: 72px;
          height: 72px;
          margin-right: 12px;
        }
        .content {
          width: 700px;
          margin-right: 75px;
          .header {
            display: flex;
            h3 {
              font-size: 16px;
              color: rgba(0, 0, 0, 0.85);
              line-height: 24px;
              margin-right: 8px;
            }
            span {
              color: #404040;
              line-height: 22px;
            }
          }
          p {
            color: #404040;
            line-height: 22px;
          }
          .description {
            width: 700px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .price-warp {
          text-align: center;
          button {
            display: flex;
            align-items: center;
          }
          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
          p {
            color: #404040;
            margin-top: 8px;
          }
          .no-permission {
            color: #b9b9b9;
          }
        }
        .disable-button {
          background: #f5f5f5;
          border: 1px solid #d9d9d9;
          color: #b9b9b9;
          img {
            filter: red;
          }
        }
      }
    }
  }
}
</style>